import { FuelConsumption, FuelConsumptionInput } from '../types/fuelConsumption';
import { fuelConsumptionService } from './fuelConsumptionService';

/**
 * Extension du service de consommation de carburant avec des méthodes supplémentaires
 * pour l'importation CSV des consommations de carburant
 */
export class FuelConsumptionExtendedService {
  /**
   * Crée une nouvelle consommation de carburant
   * @param data Données de la consommation de carburant
   * @returns ID de la consommation créée
   */
  async createFuelConsumption(
    data: Omit<FuelConsumption, 'id' | 'createdAt'>
  ): Promise<string> {
    try {
      // Convertir les données au format attendu par le service existant
      const fuelConsumptionData: FuelConsumptionInput = {
        vehicleId: data.vehicleId,
        organizationId: data.organizationId,
        date: data.date,
        amount: data.amount,
        volume: data.volume,
        supplier: data.supplier,
        receiptUrl: data.receiptUrl
      };
      
      // Utiliser la méthode create du service existant
      return await fuelConsumptionService.create(fuelConsumptionData, data.createdBy);
    } catch (error) {
      console.error('Error creating fuel consumption:', error);
      throw new Error('Failed to create fuel consumption record');
    }
  }
}

// Exporter une instance du service étendu
export const fuelConsumptionExtendedService = new FuelConsumptionExtendedService();